import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { css } from "styled-components";

shareListModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        font-family: "Roboto-Medium";
    `,
};

shareListModalStyles.sendButton = {
    variant: "primary",
    css: css`
        width: 100%;
        font-family: "Roboto-Medium";
    `,
};
